const BASE = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'}/google`;

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('authToken');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

// ── OAuth flow ─────────────────────────────────────────────────────────────────

export async function getAuthUrl(): Promise<string> {
  const res = await fetch(`${BASE}/auth-url`, { headers: authHeaders() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).detail || 'Failed to get Google auth URL');
  }
  const data = await res.json();
  return data.auth_url as string;
}

export interface GoogleStatus {
  app_configured: boolean;
  connected: boolean;
  email: string | null;
  token_expired?: boolean;
}

export async function getStatus(): Promise<GoogleStatus> {
  const res = await fetch(`${BASE}/status`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Failed to get Google Calendar status');
  return res.json();
}

export interface BusyBlock {
  start: string;
  end: string;
}

export async function getFreeBusy(start: string, end: string): Promise<BusyBlock[]> {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    const res = await fetch(
      `${BASE}/freebusy?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&tz=${encodeURIComponent(tz)}`,
      { headers: authHeaders() }
    );
    if (!res.ok) return [];
    const data = await res.json();
    if (!data.connected) return [];
    return data.busy || [];
  } catch {
    return [];
  }
}

export async function disconnect(): Promise<void> {
  const res = await fetch(`${BASE}/disconnect`, { method: 'DELETE', headers: authHeaders() });
  if (!res.ok) throw new Error('Failed to disconnect Google Calendar');
}
